export default __webpack_public_path__ + "static/termites-0ed6836046d3800fc850a02365546075.jpeg";